import React, {Component} from "react";
import {connect} from "react-redux";
import localizedData from "./../Localization/Localization";
import {surveyBegin, trackReviewReferClicks, rewardPrizeTickets, restartPatientSurvey, beginNewSurvey, getDeptStaff, cachedResults, executePersonalSurvey, updateSurvey, createPatient, getUserDetails} from "../../survey-actions";
import "react-spinner/react-spinner.css";
import ReactTurntable from "react-turntable";
import "react-turntable/assets/index.css";
import SaveRecipientDataForm from "./../Utilities/SaveRecipientDataForm";
// Make sure moment.js has the required locale data
import {Modal, Button} from "react-bootstrap";
import 'moment/locale/es';
import 'react-day-picker/lib/style.css';
import "./../ServeSurvey.scss";
import "./UIStyles.scss";

class ServeSurvey extends Component {

    constructor(props){
        super(props);

        let language = 'EN';
        if(props.location && props.location.query && props.location.query.lang!==null && props.location.query.lang !== undefined){
          if(props.location.query.lang.toUpperCase()==='ES' || props.location.query.lang.toUpperCase() === 'EN' || props.location.query.lang.toUpperCase() === 'FR'){
            localizedData.setLanguage(props.location.query.lang.toUpperCase());
            language = localizedData.getLanguage();
          }
        }

        var prizes = ['1 Raffle Entry', '2 Raffle Entries', '1 Raffle Entry', '2 Raffle Entries', '3 Raffle Entries', '2 Raffle Entries', '2 Raffle Entries','1 Raffle Entry']; 
        this.saveSurveyStatus = this.saveSurveyStatus.bind(this);
        this.executeSurvey = this.executeSurvey.bind(this);
        
        this.state = {
          npsValue: 0,
          showNextButton: true,
          currentQuestion: 0,
          showDepartmentJourneyScreen: false,
          showNoStaffJourneyScreen: false,
          showStaffJourneyScreen: false,
          selectedDepartments: [],
          showLocationBar: false,
          selectedStaff: [],
          currentStaffNumber: null,
          currentStaffDetail: {},
          currentDeptNumber: null,
          currentDeptDetail: {},
          currentDeptStaffList: null,
          completedSurvey: false,
          notYourSurvey: false,
          confirmOpen: false,
          confirmRating: 1,
          staff: null,
          restartedSurvey: false,
          executed: false,
          cyclingStaff: false,
          cyclingDept: false,
          cachedStaffRequests : [],
          fullyLoaded: false,
          syncSurvey: false,
          newSurvey: false,
          spun: false,
          prizeWinnings: null,
          showReviewPage: false,
          savedSurvey: { nps: null, selectedDay: null, departments: [], staff: [], completed: false},
          errors: {},
          language: language,
          actualTurnTable: null,
          options: {
              prizes,
              width: 400,
              height: 400,
              primaryColor: "#268BFF",
              secondaryColor: "#272CD0",
              fontStyle:{
                  color:"#fff",
                  size:"16px",
                  fontVertical:true,
                  fontWeight:"bold",
                  fontFamily:"sans-serif"
              },
              speed: 800,                  
              duration: 4000
          }

        };
        this.props.surveyBegin(this.props.tvClient, this.props.match.params.survey_url).then(() => {
            
            if(this.props.surveyData.existingSurvey!==undefined){
                var currentSurvey = this.props.surveyData.existingSurvey;
                if(currentSurvey.departments.length===0 || currentSurvey.departments === undefined){
                  currentSurvey.departments = this.props.surveyData.departments;
                }
                if(this.props.surveyData.language!==undefined && this.props.surveyData.language!==null){
                  localizedData.setLanguage(this.props.surveyData.language);
                  this.setState({ showReviewPage: this.props.surveyData.incentiveWheel, savedSurvey: currentSurvey, fullyLoaded: true, language: this.props.surveyData.language });
                } else{
                  this.setState({ showReviewPage: this.props.surveyData.incentiveWheel, savedSurvey: currentSurvey, fullyLoaded: true });  
                }
            } else{
                var currentSurvey = this.state.savedSurvey;
                if(this.state.savedSurvey.departments.length===0 || this.state.savedSurvey.departments === undefined){
                  currentSurvey.departments = this.props.surveyData.departments;
                }
                var newLanguage = this.props.surveyData.urlInfo[0].survey_lang;
                if(newLanguage !== undefined&& newLanguage !== null){
                  localizedData.setLanguage(newLanguage);
                  this.setState({language: newLanguage});
                }
                if(this.props.surveyData.recentlyCompleted===true){
                  this.setState({ completedSurvey: true });
                } else if(this.props.surveyData.notYourSurvey===true){
                  this.setState({ notYourSurvey: true });
                }else{
                  currentSurvey.selectedDay = new Date(this.props.surveyData.urlInfo[0].created);
                  this.setState({ showReviewPage: this.props.surveyData.incentiveWheel, fullyLoaded: true, newSurvey: false, savedSurvey: currentSurvey });  
                }
                
            }


        });
    }
 



    startPrizeDrawing(){
      var els = document.getElementsByClassName('react-turntable-section-btn');
      for(var i = 0; i<els.length; i++){
        els[i].classList.add('removeItem');
      }
      return true;
    }

    finishPrizeDrawing(prize){
      if(this.state.spun===true && (this.state.savedSurvey.nps === 4 || this.state.savedSurvey.nps === 5 || this.state.savedSurvey.nps === '4' || this.state.savedSurvey.nps === '5')){
        this.state.setState({ showReviewPage: true });
        //this.state.setState({ showReviewPage: false });
      }
      else{
        let finalPrize = localizedData.you_won + ' ' + prize + '!';
        this.setState({ spun: true, prizeWinnings: finalPrize });
        this.props.rewardPrizeTickets(this.props.tvClient, prize, this.props.surveyData.urlInfo[0].url_id).then(()=>{
          //if(this.state.savedSurvey.nps === 4 || this.state.savedSurvey.nps === 5){
            this.setState({showReviewPage: true});  
            //this.setState({ showReviewPage: false, completedSurvey: true });
          //} else{
            //this.setState({ showReviewPage: false, completedSurvey: true });
          //}
        });
      }
    }

    executeSurvey(){
      if(this.state.executed===false){
        this.props.executePersonalSurvey(this.props.tvClient, this.props.surveyData.urlInfo[0]).then(()=>{
          this.setState({executed: true }); 
        }); 
      }
    }

    saveSurveyStatus(){
        if(this.state.syncSurvey){
            this.props.updateSurvey(this.props.tvClient, this.state.savedSurvey, this.props.surveyData.urlInfo[0], this.state.currentQuestion, false, localizedData.getLanguage()); 
            this.setState({syncSurvey: false, newSurvey: false}); 
        }
    }

   updateLocalizedWheelText(){
    if(localizedData.getLanguage()==='ES'){
      // Update the Spin Button Text
      var spinButton = document.getElementsByClassName('react-turntable-section-btn');
      for(var i=0; i<spinButton.length; i++){
        spinButton[i].innerText='Girar';
        spinButton[i].innerHTML='Girar';
      }
    } 
   } 

  updateReviewInfo(site){
    console.log('clicked on the review');
    /* onClick={()=> {this.updateReviewInfo.bind(this,"google")}} */
  }

   restartSurvey(e){
    this.props.restartPatientSurvey(this.props.tvClient, this.props.surveyData.urlInfo[0], this.props.surveyData).then( () => {
      this.setState({ restartedSurvey: true, fullyLoaded: true });
    });
   }

    handleNpsClick(rating, event){
      if(rating===0 || rating==='0'){
        if(this.state.npsValue.toString()==='1' || this.state.npsValue.toString()==='2'){
            this.setState({ confirmOpen: true, confirmRating: this.state.npsValue });
        } else{
          let survey = this.state.savedSurvey;
          let sync = false;
          let originalNps = this.state.savedSurvey.nps;
          survey.nps = parseInt(this.state.npsValue);
          survey.completed = true;

          if(originalNps!==survey.nps){
              sync = true;
          }

          var locationbar = false;
          
          for(var i=0; i<survey.staff.length; i++){
            if(survey.staff[i].reviews!==undefined && survey.staff[i].reviews!==null && survey.staff[i].reviews.google!==undefined && survey.staff[i].reviews.google!==null){
              locationbar=true;
              break;
            }
          }
          //this.props.rewardPrizeTickets(this.props.tvClient, 5, this.props.surveyData.urlInfo[0].url_id);
          this.setState({ syncSurvey: sync, savedSurvey: survey, showLocationBar: locationbar }, () => { this.advanceSurveyFrom(this); this.updateLocalizedWheelText(); window.parent.postMessage('SURVEY_COMPLETE', '*'); });
        }
      } else{
        const value = event.target.getAttribute('data-value');
        const rating = event.target.parentElement;

        // Remove previous rating classes
        rating.classList.remove('filled-1', 'filled-2', 'filled-3', 'filled-4', 'filled-5','filled-6', 'filled-7', 'filled-8', 'filled-9', 'filled-10');
        
        // Add new rating class based on the clicked button
        rating.classList.add(`filled-${value}`);

        this.setState({ npsValue: value});
      }

    }

  handleClose(e) {
    this.setState({ confirmOpen: false });
  }

  handleConfirm(e){
    let survey = this.state.savedSurvey;
    let sync = false;
    let originalNps = this.state.savedSurvey.nps;
    survey.nps = this.state.confirmRating;
    survey.completed = true;


        var locationbar = false;
        for(var i=0; i<survey.staff.length; i++){
                    if(survey.staff[i].reviews!==undefined && survey.staff[i].reviews!==null && survey.staff[i].reviews.google!==undefined && survey.staff[i].reviews.google!==null){
            locationbar=true;
            break;
          }
        }

    if(originalNps!==survey.nps){
        sync = true;
    }
    //this.props.rewardPrizeTickets(this.props.tvClient, 5, this.props.surveyData.urlInfo[0].url_id);
    this.setState({ syncSurvey: sync, savedSurvey: survey, showLocationBar: locationbar }, () => { this.advanceSurveyFrom(this); this.updateLocalizedWheelText(); });          
  }    

    retrieveUserDetails(){
        this.props.getUserDetails(this.props.surveyData).then(() => {
            var theQuestion = this.props.surveyData.questionInfo.length-2;
            this.setState({ fullyLoaded: true, currentQuestion: theQuestion });
        });
    }

    localizeDepartment(selectedDept){
      let finalName = selectedDept.name;
      if(localizedData.getLanguage()==='ES'){
        if(selectedDept.name_locale_es!==null && selectedDept.name_locale_es!==undefined){
          finalName = selectedDept.name_locale_es;
        }
      }

      return finalName;
    }

    chooseDepartments(selectedDept, e){
         e.stopPropagation()
        var currentDepartments = this.state.savedSurvey.departments;
        var originalDepts = this.state.savedSurvey.departments.slice(); 
        let sync = false;
        var foundIt = false;
        for (var i = 0, l = currentDepartments.length; i < l; i++) {
            if(currentDepartments[i].key === selectedDept.key) {
              foundIt=true;
              e.target.classList.remove("activeDept");
              e.target.parentElement.classList.remove("addCheckMark");
              currentDepartments.splice(i, 1);
              break;
            }
        }   

        if(!foundIt){
            e.target.classList.add("activeDept");
            e.target.parentElement.classList.add("addCheckMark");
            currentDepartments.push(selectedDept);
        }

        if(currentDepartments!==originalDepts){
            sync = true;
        }

        var currentSurvey = this.state.savedSurvey;
        currentSurvey.departments = currentDepartments;
        this.setState({
            savedSurvey: currentSurvey,
            syncSurvey: sync
        });

    }

    chooseStaff(selectedStaff, e){
        e.stopPropagation();
        var originalStaff= this.state.savedSurvey.staff.slice(); 
        let sync = false;
        var currentStaff = this.state.savedSurvey.staff;
        var foundIt = false;
        for (var i = 0, l = currentStaff.length; i < l; i++) {
            if(currentStaff[i].staff_id === selectedStaff.staff_id) {
              foundIt=true;
              e.target.parentElement.classList.remove("activeDept");
              //e.target.parentElement.classList.remove("addCheckMark");
              currentStaff.splice(i, 1);
              break;
            }
        }   

        if(!foundIt){
            e.target.parentElement.classList.add("activeDept");
            //e.target.parentElement.classList.add("addCheckMark");
            currentStaff.push(selectedStaff);
        }

        if(currentStaff!==originalStaff){
            sync = true;
        }

        var currentSurvey = this.state.savedSurvey;
        currentSurvey.staff = currentStaff;        

        this.setState({
            savedSurvey: currentSurvey,
            syncSurvey: sync
        });

    }

    chooseStaffEndorsement(selectedEndorsement, person, e){
        e.stopPropagation();
        let originalStaffEndorsements = this.state.savedSurvey.staff.splice();

        for (var i = this.state.savedSurvey.staff.length - 1; i >= 0; i--) {
            if(this.state.savedSurvey.staff[i].staff_id===person.staff_id){
                if(person.badges!==undefined){
                    var foundOne = false;
                    for (var j = person.badges.length - 1; j >= 0; j--) {
                        if(person.badges[j].endorsement_id===selectedEndorsement.endorsement_id){
                            // remove it
                            foundOne = true;
                            person.badges.splice(j, 1);
                            this.setState({ currentStaffDetail: person });
                            e.target.classList.remove("activeDept");
                            e.target.parentElement.classList.remove("addCheckMark");
                            break;
                        }
                    }
                    if(!foundOne){
                        person.badges.push(selectedEndorsement);
                        this.setState({ currentStaffDetail: person });
                        e.target.classList.add("activeDept");
                        e.target.parentElement.classList.add("addCheckMark");
                    }
                    
                }
                else{
                    person.badges=[];
                    person.badges.push(selectedEndorsement);
                    this.setState({ currentStaffDetail: person });
                    e.target.classList.add("activeDept");
                    e.target.parentElement.classList.add("addCheckMark");
                }
                break;
            }
        }

        if(originalStaffEndorsements!==this.state.savedSurvey.staff){
            this.setState({ syncSurvey: true })
        }
    }

    openSeverityDrawer(e){
      e.stopPropagation();
      e.target.offsetParent.getElementsByClassName("badge-card__rating-text")[0].classList.remove('hidden');
      e.target.offsetParent.getElementsByClassName("badge-card__rating-text-link")[0].classList.add('hidden');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            e.target.parentElement.parentElement.parentElement.getElementsByClassName('badge-card__ratings')[0].style.height = 'auto';
            e.target.parentElement.parentElement.parentElement.getElementsByClassName('badge-card__ratings')[0].style.opacity = '1';
            e.target.parentElement.parentElement.parentElement.getElementsByClassName('badge-card__ratings')[0].classList.remove("closed");
        });
      });
    }

    adjustSeverityRating(e, badgeSeverityName){

      let wasBad = e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.contains('bad');
      let wasAverage = e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.contains('average');
      let wasGood = e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.contains('good');
      let isSet = false;
      e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.remove('bad');
      e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.remove('average');
      e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.remove('good');

      if(badgeSeverityName==='Bad' && !wasBad){
        e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.add('bad');
        isSet = true;
      } else if(badgeSeverityName==='Okay' && !wasAverage){
        e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.add('average');
        isSet = true;
      } else if(badgeSeverityName==='Great' && !wasGood){
        e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.add('good');
        isSet = true;
      }

      if(badgeSeverityName==='Bad' && wasBad){
        e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.remove('bad');
        isSet = false;
      } else if(badgeSeverityName==='Okay' && wasAverage){
        e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.remove('average');
        isSet = false;
      } else if(badgeSeverityName==='Great' && wasGood){
        e.getElementsByClassName("badge-card__icon-overlay-survey")[0].classList.remove('good');
        isSet = false;
      }

      
      if(isSet){
        e.getElementsByClassName("badge-card__rating-text")[0].classList.add('hidden');
        e.getElementsByClassName("badge-card__rating-text-link")[0].classList.remove('hidden');
      } else {
        e.classList.remove("addCheckMark");
      }

      return isSet;

    }

    chooseSeverityStaffEndorsement(selectedEndorsement, person, e){
      e.stopPropagation();
      
      let badgeSeverityName = e.target.innerText;
      selectedEndorsement.severity = true;
      selectedEndorsement.severityLevel = badgeSeverityName;
      let originalStaffEndorsements = this.state.savedSurvey.staff.splice();
      for (var i = this.state.savedSurvey.staff.length - 1; i >= 0; i--) {
          if(this.state.savedSurvey.staff[i].staff_id===person.staff_id){
              if(person.badges!==undefined){
                  var foundOne = false;
                  for (var j = person.badges.length - 1; j >= 0; j--) {
                      if(person.badges[j].endorsement_id===selectedEndorsement.endorsement_id){
                          foundOne = true;
                          
                          e.target.offsetParent.classList.add("addCheckMark");
                          e.target.parentElement.parentElement.style.height = e.target.parentElement.parentElement.offsetHeight + 'px';
                          e.target.parentElement.parentElement.style.opacity = '1';
                          
                          let reset = this.adjustSeverityRating(e.target.offsetParent, badgeSeverityName);

                          if(reset){
                            person.badges[j].severityLevel = badgeSeverityName;
                            this.setState({ currentStaffDetail: person });
                            requestAnimationFrame(() => {
                              requestAnimationFrame(() => {
                                  e.target.parentElement.parentElement.style.height = '0';
                                  e.target.parentElement.parentElement.style.opacity = '0';
                                  e.target.parentElement.parentElement.classList.add("closed");
                              });
                            });
                          } else {
                            e.target.classList.remove("activeDept");
                            person.badges.splice(j, 1);
                            this.setState({ currentStaffDetail: person });
                          }

                          break;
                      }
                  }
                  if(!foundOne){
                      person.badges.push(selectedEndorsement);
                      this.setState({ currentStaffDetail: person });
                      e.target.classList.add("activeDept");
                      e.target.offsetParent.classList.add("addCheckMark");
                      e.target.offsetParent.getElementsByClassName("badge-card__rating-text")[0].classList.add('hidden');
                      e.target.offsetParent.getElementsByClassName("badge-card__rating-text-link")[0].classList.remove('hidden');

                      let reset = this.adjustSeverityRating(e.target.offsetParent, badgeSeverityName);
                      
                      e.target.parentElement.parentElement.style.height = e.target.parentElement.parentElement.offsetHeight + 'px';
                      e.target.parentElement.parentElement.style.opacity = '1';
                      
                      requestAnimationFrame(() => {
                          requestAnimationFrame(() => {
                              e.target.parentElement.parentElement.style.height = '0';
                              e.target.parentElement.parentElement.style.opacity = '0';
                              e.target.parentElement.parentElement.classList.add("closed");
                          });
                      });


                  }
                  
              }
              else{
                  person.badges=[];
                  person.badges.push(selectedEndorsement);
                  this.setState({ currentStaffDetail: person });
                  e.target.classList.add("activeDept");
                  e.target.offsetParent.classList.add("addCheckMark");
                  e.target.offsetParent.getElementsByClassName("badge-card__rating-text")[0].classList.add('hidden');
                  e.target.offsetParent.getElementsByClassName("badge-card__rating-text-link")[0].classList.remove('hidden');
                  
                  let reset = this.adjustSeverityRating(e.target.offsetParent, badgeSeverityName);

                  e.target.parentElement.parentElement.style.height = e.target.parentElement.parentElement.offsetHeight + 'px';
                  e.target.parentElement.parentElement.style.opacity = '1';
                  
                  requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                          e.target.parentElement.parentElement.style.height = '0';
                          e.target.parentElement.parentElement.style.opacity = '0';
                          e.target.parentElement.parentElement.classList.add("closed");
                      });
                  });
              }
              break;
          }
      }

      if(originalStaffEndorsements!==this.state.savedSurvey.staff){
          this.setState({ syncSurvey: true })
      }

  }


    createNewSurvey(){
        this.props.beginNewSurvey(this.props.surveyData).then(() => {
            this.setState({ fullyLoaded: true, newSurvey: true });
        });
    }

    chooseSeverityDepartmentEndorsement(selectedEndorsement, department, e){
      e.stopPropagation();
      let badgeSeverityName = e.target.innerText;
      selectedEndorsement.severity = true;
      selectedEndorsement.severityLevel = badgeSeverityName;
      let originalDeptEndorsements = this.state.savedSurvey.departments.splice();
      for (var i = this.state.savedSurvey.departments.length - 1; i >= 0; i--) {
          if(this.state.savedSurvey.departments[i].key===department.key){
              if(department.badges!==undefined){
                  var foundOne = false;
                  for (var j = department.badges.length - 1; j >= 0; j--) {
                      if(department.badges[j].endorsement_id===selectedEndorsement.endorsement_id){
                          // remove it
                          foundOne = true;
                          
                          e.target.offsetParent.classList.add("addCheckMark");
                          e.target.parentElement.parentElement.style.height = e.target.parentElement.parentElement.offsetHeight + 'px';
                          e.target.parentElement.parentElement.style.opacity = '1';
                          
                          let reset = this.adjustSeverityRating(e.target.offsetParent, badgeSeverityName);

                          if(reset){
                            department.badges[j].severityLevel = badgeSeverityName;
                            this.setState({ currentDeptDetail: department });
                            requestAnimationFrame(() => {
                              requestAnimationFrame(() => {
                                  e.target.parentElement.parentElement.style.height = '0';
                                  e.target.parentElement.parentElement.style.opacity = '0';
                                  e.target.parentElement.parentElement.classList.add("closed");
                              });
                            });
                          } else {
                            e.target.classList.remove("activeDept");
                            department.badges.splice(j, 1);
                            this.setState({ currentDeptDetail: department });
                          }

                          break;

                      }
                  }
                  if(!foundOne){
                      department.badges.push(selectedEndorsement);
                      this.setState({ currentDeptDetail: department });
                      e.target.classList.add("activeDept");
                      e.target.offsetParent.classList.add("addCheckMark");
                      e.target.offsetParent.getElementsByClassName("badge-card__rating-text")[0].classList.add('hidden');
                      e.target.offsetParent.getElementsByClassName("badge-card__rating-text-link")[0].classList.remove('hidden');
                      
                      let reset = this.adjustSeverityRating(e.target.offsetParent, badgeSeverityName);
    
                      e.target.parentElement.parentElement.style.height = e.target.parentElement.parentElement.offsetHeight + 'px';
                      e.target.parentElement.parentElement.style.opacity = '1';
                      
                      requestAnimationFrame(() => {
                          requestAnimationFrame(() => {
                              e.target.parentElement.parentElement.style.height = '0';
                              e.target.parentElement.parentElement.style.opacity = '0';
                              e.target.parentElement.parentElement.classList.add("closed");
                          });
                      });
                  }
                  
              }
              else{
                  department.badges=[];
                  department.badges.push(selectedEndorsement);
                  this.setState({ currentDeptDetail: department });
                  e.target.classList.add("activeDept");
                  e.target.offsetParent.classList.add("addCheckMark");
                  e.target.offsetParent.getElementsByClassName("badge-card__rating-text")[0].classList.add('hidden');
                  e.target.offsetParent.getElementsByClassName("badge-card__rating-text-link")[0].classList.remove('hidden');
                  
                  let reset = this.adjustSeverityRating(e.target.offsetParent, badgeSeverityName);

                  e.target.parentElement.parentElement.style.height = e.target.parentElement.parentElement.offsetHeight + 'px';
                  e.target.parentElement.parentElement.style.opacity = '1';
                  
                  requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                          e.target.parentElement.parentElement.style.height = '0';
                          e.target.parentElement.parentElement.style.opacity = '0';
                          e.target.parentElement.parentElement.classList.add("closed");
                      });
                  });
              }
              break;
          }
      }
      if(originalDeptEndorsements!==this.state.savedSurvey.departments){
          this.setState({ syncSurvey: true })
      }
  }

    chooseDepartmentEndorsement(selectedEndorsement, department, e){
        e.stopPropagation();
        let originalDeptEndorsements = this.state.savedSurvey.departments.splice();
        for (var i = this.state.savedSurvey.departments.length - 1; i >= 0; i--) {
            if(this.state.savedSurvey.departments[i].key===department.key){
                if(department.badges!==undefined){
                    var foundOne = false;
                    for (var i = department.badges.length - 1; i >= 0; i--) {
                        if(department.badges[i].endorsement_id===selectedEndorsement.endorsement_id){
                            // remove it
                            foundOne = true;
                            department.badges.splice(i, 1);
                            this.setState({ currentDeptDetail: department });
                            e.target.classList.remove("activeDept");
                            e.target.parentElement.classList.remove("addCheckMark");
                            break;
                        }
                    }
                    if(!foundOne){
                        department.badges.push(selectedEndorsement);
                        this.setState({ currentDeptDetail: department });
                        e.target.classList.add("activeDept");
                        e.target.parentElement.classList.add("addCheckMark");
                    }
                    
                }
                else{
                    department.badges=[];
                    department.badges.push(selectedEndorsement);
                    this.setState({ currentDeptDetail: department });
                    e.target.classList.add("activeDept");
                    e.target.parentElement.classList.add("addCheckMark");
                }
                break;
            }
        }
        if(originalDeptEndorsements!==this.state.savedSurvey.departments){
            this.setState({ syncSurvey: true })
        }
    }

    generateSeveritySelected(endorsement, entity){
      if(entity.badges!==undefined){
          var foundIt = false;
          for (var i = entity.badges.length - 1; i >= 0; i--) {
              if(entity.badges[i].endorsement_id===endorsement.endorsement_id){
                    foundIt=true;
                    break;
              }
          }
          if(foundIt){
              return true;
          }
          else{
              return false;
          }
      } else{
          return false;
      } 
    }

    generateSeverityName(endorsement, entity){
      if(entity.badges!==undefined){
          var foundIt = '';
          for (var i = entity.badges.length - 1; i >= 0; i--) {
              if(entity.badges[i].endorsement_id===endorsement.endorsement_id){
                    foundIt=entity.badges[i].severityLevel.toLowerCase();
                    break;
              }
          }
          if(foundIt==='great'){ foundIt='good'; }
          if(foundIt==='average' || foundIt==='okay'){ foundIt='average'; }
          return foundIt;
      } else{
          return '';
      } 
    }

    generateSeverityClassNames(endorsement, entity, name){
      if(entity.badges!==undefined){
          var foundIt = false;
          for (var i = entity.badges.length - 1; i >= 0; i--) {
              if(entity.badges[i].endorsement_id===endorsement.endorsement_id){
                  if(name===entity.badges[i].severityLevel){
                    foundIt=true;
                    break;
                  }

              }
          }
          if(foundIt){
              return true;
          }
          else{
              return false;
          }
      } else{
          return false;
      }
  }

    generateClassNames(endorsement, entity){
      
        if(entity.badges!==undefined){
            var foundIt = false;
            for (var i = entity.badges.length - 1; i >= 0; i--) {
                if(entity.badges[i].endorsement_id===endorsement.endorsement_id){
                    foundIt=true;
                    break;
                }
            }
            if(foundIt){
                return true;
            }
            else{
                return false;
            }
        } else{
            return false;
        }
    }


    findNextPage(){
        let newSurveyData = this.props.surveyData;
        
        for (var i = this.props.surveyData.questionInfo.length - 1; i >= 0; i--) {
            if(this.props.surveyData.questionInfo[i].page_id === newSurveyData.currentPage){
                newSurveyData.currentPage = this.props.surveyData.questionInfo[i+1].page_id;
                newSurveyData.firstPage = false;
                break;
            }
        }

        return newSurveyData;
    }

    findPreviousPage(){
        let newSurveyData = this.props.surveyData;
        
        for (var i = this.props.surveyData.questionInfo.length - 1; i >= 0; i--) {
            if(this.props.surveyData.questionInfo[i].page_id === newSurveyData.currentPage){
                newSurveyData.currentPage = this.props.surveyData.questionInfo[i-1].page_id;
                if(this.props.surveyData.questionInfo[i-2]===undefined){
                    newSurveyData.firstPage = true;
                    this.setState({ showDepartmentJourneyScreen: false, showStaffJourneyScreen: false })
                }
                break;
            }
        }

        return newSurveyData;
    }

    handleStaffFeedbackChange(event){
        //event.stopPropagation();
        if(event.target.value!==undefined && event.target.value!==null){
            var person = this.state.currentStaffDetail;
            person.feedback = event.target.value;
            this.setState({ currentStaffDetail: person, syncSurvey: true });            
        }
    }

    handleDeptFeedbackChange(event){
        //event.stopPropagation();
        if(event.target.value!==undefined && event.target.value!==null){
            var dept = this.state.currentDeptDetail;
            dept.feedback = event.target.value;
            this.setState({ currentDeptDetail: dept, syncSurvey: true });            
        }
    }

    isDepartmentSelected(dept){
        var isSelected = false;
        for (var i = this.state.savedSurvey.departments.length - 1; i >= 0; i--) {
           if(this.state.savedSurvey.departments[i].key === dept){
            isSelected=true;
           }
        }
        return isSelected;
    }

    isStaffSelected(staff){
        var isSelected = false;
        for (var i = this.state.savedSurvey.staff.length - 1; i >= 0; i--) {
           if(this.state.savedSurvey.staff[i].staff_id === staff){
            isSelected=true;
           }
        }
        return isSelected;
    }

    staffCached(){
        var strDepts = '';
        for (var i = this.state.savedSurvey.departments.length - 1; i >= 0; i--) {
            strDepts += this.state.savedSurvey.departments[i].key;
        }  

        var foundIt = false;

        for (var j = this.state.cachedStaffRequests.length - 1; j >= 0; j--) {
            if(this.state.cachedStaffRequests[j].depts===strDepts){
                foundIt = true;
                break;
            }
        }
    

        return foundIt;

    }

    backwardDepartmentJourney(currentStep, from){
        
          var orderedDepts = this.props.surveyData.urlInfo[0].dept_list;
          var departmentDetails = this.props.surveyData.departments;
         
          // Find where we are in the list
          var currentJourneyDept = this.state.showNoStaffJourneyScreen ? this.state.currentDeptDetail.key : this.state.currentDeptStaffList.details.key;
          var currentOrderedPos = 0;
          
          
          for(var i=0; i<orderedDepts.length; i++){
            if(currentJourneyDept.toString()===orderedDepts[i].toString()){
              currentOrderedPos = i;
              break;
            }
          }

          if(currentOrderedPos===0 && from!=='staff'){
            // at the beginning so next one goes to page 1
            this.setState({
                surveyData: this.findPreviousPage(),
                currentQuestion: this.state.currentQuestion-1,
                showDepartmentJourneyScreen: false,
                showStaffJourneyScreen: false,
                showNoStaffJourneyScreen: false
            }); 
          }
          else if(currentOrderedPos===0 && from==='staff'){
            this.setState({
                showDepartmentJourneyScreen: true,
                showStaffJourneyScreen: false,
                showNoStaffJourneyScreen: false
            });             
          } else if(from==='staff'){
            // Should set the department detail here 
            this.setState({ showDepartmentJourneyScreen: true, showNoStaffJourneyScreen: false, showStaffJourneyScreen: false });
          } else{
            if(this.state.showNoStaffJourneyScreen){
              var finalDept = {};
              for(var z=0; z<departmentDetails.length;z++){
                if(departmentDetails[z].key.toString() === orderedDepts[currentOrderedPos-1].toString()){
                  finalDept = departmentDetails[z];
                }
              }

              this.setState({
                  currentDeptDetail: finalDept,
                  showDepartmentJourneyScreen: false,
                  showStaffJourneyScreen: false,
                  showNoStaffJourneyScreen: true
              }); 
            } else{
              var finalDept = null;
              for(var z=0; z<departmentDetails.length;z++){
                if(departmentDetails[z].key.toString() === orderedDepts[currentOrderedPos-1].toString()){
                  finalDept = departmentDetails[z];
                }
              }
              // does the previous department have staff
              if(this.props.surveyData.staffForDepartments[orderedDepts[currentOrderedPos-1]]!==undefined){
                this.setState({ showDepartmentJourneyScreen: true, showStaffJourneyScreen: false, showNoStaffJourneyScreen: false, 'currentDeptStaffList': this.props.surveyData.staffForDepartments[orderedDepts[currentOrderedPos-1]] }, ()=>{
              this.backwardStaffEndorsementJourney(currentStep, 'last');
            });
              } else{
                  this.setState({
                  currentDeptDetail: finalDept,
                  showDepartmentJourneyScreen: false,
                  showStaffJourneyScreen: false,
                  showNoStaffJourneyScreen: true
                }); 
              }
            }
          }
    }

    advanceDepartmentJourney(currentStep){
          var orderedDepts = this.props.surveyData.urlInfo[0].dept_list;
          var departmentDetails = this.props.surveyData.departments;
          var noStaff = false;
          //Need to configure the state for current details

          if((this.state.currentDeptStaffList===null && !this.state.showNoStaffJourneyScreen) || this.state.surveyData.firstPage===true){
              // First time and first element
              var theStaffList = [];
              var noStaffDept = null;
              var i = 0;
              for(var j=0; j<departmentDetails.length; j++){
                if(departmentDetails[j].key.toString()===orderedDepts[i].toString()){

                  if(this.props.surveyData.staffForDepartments[orderedDepts[i]]===undefined){
                    noStaffDept=departmentDetails[j];
                    noStaff=true;
                  } else{
                  this.props.surveyData.staffForDepartments[orderedDepts[i]].details = departmentDetails[j];
                  break;
                }

                }
              }

              if(noStaff){

                this.setState({ currentDeptDetail: noStaffDept,
                                surveyData: this.findNextPage(), 
                                currentQuestion: this.state.currentQuestion+1, 
                                'showDepartmentJourneyScreen': false, 
                                'showStaffJourneyScreen': false,
                                'showNoStaffJourneyScreen': true
                                 });
                this.executeSurvey();
              } else{
              this.setState({ surveyData: this.findNextPage(), 
                              currentQuestion: this.state.currentQuestion+1, 
                              'showDepartmentJourneyScreen': true, 
                              'showStaffJourneyScreen': false,
                                'showNoStaffJourneyScreen': false,
                              'currentDeptStaffList': this.props.surveyData.staffForDepartments[orderedDepts[i]] });
              this.executeSurvey();
              }

          }
          else{
            // Find where we are in the list
            var currentJourneyDept = this.state.showNoStaffJourneyScreen ? this.state.currentDeptDetail.key : this.state.currentDeptStaffList.details.key;
            var currentOrderedPos = 0;
            for(var i=0; i<orderedDepts.length; i++){
              if(currentJourneyDept.toString()===orderedDepts[i].toString()){
                currentOrderedPos = i;
                break;
              }
            }

            if(currentOrderedPos+1 < orderedDepts.length){

              var deptStaff = [];
              if(this.props.surveyData.staffForDepartments[orderedDepts[currentOrderedPos+1]] !== undefined){
                  // no staff are listed for this department
                 
                for(var k=0; k<departmentDetails.length; k++){
                  if(departmentDetails[k].key.toString()===orderedDepts[currentOrderedPos+1].toString()){
                    this.props.surveyData.staffForDepartments[orderedDepts[currentOrderedPos+1]].details = departmentDetails[k];
                    break;
                  }
                }

                deptStaff = this.props.surveyData.staffForDepartments[orderedDepts[currentOrderedPos+1]];
                this.setState({ 'showDepartmentJourneyScreen': true, 'showStaffJourneyScreen': false, 'showNoStaffJourneyScreen': false, 'currentDeptStaffList': deptStaff });
              }
              else{
                deptStaff = [];
                for(var j=0; j<departmentDetails.length; j++){
                  if(departmentDetails[j].key.toString()===orderedDepts[currentOrderedPos+1].toString()){
                    deptStaff.details = departmentDetails[j];
                    break;
                  }
                 }    

                if(currentOrderedPos+1===orderedDepts.length-1){
                 if(deptStaff.details.display){

                      var currentDepartments = this.state.savedSurvey.departments;
                      let sync = false;

                      if(currentDepartments.length===0){
                        sync = true;
                        currentDepartments.push(deptStaff.details);
                        } else{
                          for (var i = currentDepartments.length - 1; i >= 0; i--) {
                            if(currentDepartments[i].key.toString()===deptStaff.details.key.toString()){
                              currentDepartments[i] = deptStaff.details;
                            }
                          }
                      }

                      var currentSurvey = this.state.savedSurvey;
                      currentSurvey.departments = currentDepartments;

                     this.setState({
                        currentDeptDetail: deptStaff.details,
                        showStaffJourneyScreen: false,
                        showDepartmentJourneyScreen: false,
                          showNoStaffJourneyScreen: false,
                        savedSurvey: currentSurvey,
                        syncSurvey: sync,
                        surveyData: this.findNextPage(),
                        currentQuestion: this.state.currentQuestion+1});
                  }
                }
                else{
                    var currentDepartments = this.state.savedSurvey.departments;
                    for (var i = currentDepartments.length - 1; i >= 0; i--) {
                            if(currentDepartments[i].key.toString()===deptStaff.details.key.toString()){
                              currentDepartments[i] = deptStaff.details;
                            }
                          }
                          var currentSurvey = this.state.savedSurvey;
                        currentSurvey.departments = currentDepartments;

                      this.setState({
                          currentDeptDetail: deptStaff.details,
                          showStaffJourneyScreen: false,
                          showDepartmentJourneyScreen: false,
                          showNoStaffJourneyScreen: true,
                          savedSurvey: currentSurvey,
                          syncSurvey: true});
                 }
              }

            } else{
                if(orderedDepts.length===1){
                        let tempSurvey = this.findNextPage();
                        tempSurvey.currentPage='page-4';
                        this.setState({
                            surveyData: tempSurvey,
                            currentQuestion: this.state.currentQuestion+1,
                            showNoStaffJourneyScreen: false
                        });
                    
                }
            }             
            this.saveSurveyStatus();
          }

    }

    advanceStaffEndorsementsJourney(currentStep, from){

        var originalStaff= this.state.savedSurvey.staff.slice();
        var currentStaffIs = this.state.currentStaffDetail;
        var currStaffOrderNumber = -1;

        var allDepartmentStaff = [];
        for(var i=0; i<originalStaff.length; i++){
          if(originalStaff[i].department_id.toString()===this.state.currentDeptStaffList.details.key){
            allDepartmentStaff.push(originalStaff[i]);
          }
        }

        for(var j=0; j<allDepartmentStaff.length; j++){
          if(currentStaffIs.staff_id!==undefined){
              if(currentStaffIs.staff_id===allDepartmentStaff[j].staff_id){
                currStaffOrderNumber = j+1;
              }
            }
        }

        if(from==='first' && allDepartmentStaff.length!==0){
            this.setState({ currentStaffDetail: allDepartmentStaff[0], showDepartmentJourneyScreen: false, showStaffJourneyScreen: true });
        } else if(currStaffOrderNumber>=allDepartmentStaff.length || allDepartmentStaff.length===0){
          // Means that we need to go to the next department
          this.advanceDepartmentJourney(currentStep);
        }
        else{
          var newStaffToShow = (currentStaffIs.staff_id!==undefined) ? allDepartmentStaff[currStaffOrderNumber] : allDepartmentStaff[0];
          this.setState({ currentStaffDetail: newStaffToShow, showDepartmentJourneyScreen: false, showStaffJourneyScreen: true });
        }

        window.scrollTo(0,0);

    }

    backwardStaffEndorsementJourney(currentStep, from){

        if(from==='facility'){
            // Step 1: Find the department right before Facility.
            var orderedDepts = this.props.surveyData.urlInfo[0].dept_list;
            var facilityDeptKey = orderedDepts[orderedDepts.length - 1]; // Assuming facility is the last in the list
            var deptBeforeFacilityKey = orderedDepts[orderedDepts.length - 2];
            var departmentDetails = this.props.surveyData.departments;
            var deptBeforeFacilityDetails = departmentDetails.find(d => d.key.toString() === deptBeforeFacilityKey.toString());

            // Step 2: Check if the department before facility had staff or not.
            var hasStaff = this.props.surveyData.staffForDepartments[deptBeforeFacilityKey] !== undefined;

            // Update to the correct page for the department before Facility
            if (hasStaff) {
              // Go back to the Staff Endorsement screen for the LAST staff of the previous department
              // (The rest of this function handles the back-stepping for staff endorsements)
              this.setState({ 
                surveyData: this.findPreviousPage(), // Moves page-4 -> page-3
                currentQuestion: this.state.currentQuestion-1,
                'currentDeptStaffList': this.props.surveyData.staffForDepartments[deptBeforeFacilityKey],
                showNoStaffJourneyScreen: false,
                showStaffJourneyScreen: true // This will be correctly handled by the rest of the method
              });
              from = 'last'; // Change 'from' flag to trigger last staff logic below
            } else {
              // No staff, go back to the Department Endorsement screen
              this.setState({ 
                  surveyData: this.findPreviousPage(), // Moves page-4 -> page-3
                  currentQuestion: this.state.currentQuestion-1,
                  currentDeptDetail: deptBeforeFacilityDetails,
                  showNoStaffJourneyScreen: true,
                  showStaffJourneyScreen: false
              });
              window.scrollTo(0,0);
              return; // CRITICAL: Stop execution here to avoid running staff-related logic
            }
        }
        var originalStaff= this.state.savedSurvey.staff.slice();
        var currentStaffIs = this.state.currentStaffDetail;
        var currStaffOrderNumber = -1;

        var allDepartmentStaff = [];
        for(var i=0; i<originalStaff.length; i++){
          if(originalStaff[i].department_id.toString()===this.state.currentDeptStaffList.details.key){
            allDepartmentStaff.push(originalStaff[i]);
          }
        }

        for(var j=0; j<allDepartmentStaff.length; j++){
           if(currentStaffIs.staff_id!==undefined){
              if(currentStaffIs.staff_id===allDepartmentStaff[j].staff_id){
                currStaffOrderNumber = j-1;
              }
            }
        }

        if( (from==='last' || from==='facility') && allDepartmentStaff.length!==0){
          this.setState({ currentStaffDetail: allDepartmentStaff[allDepartmentStaff.length-1], showDepartmentJourneyScreen: false, showStaffJourneyScreen: true });
        } else if(currStaffOrderNumber<0 || allDepartmentStaff.length===0){
          // Means that we need to go to the last department
          this.backwardDepartmentJourney(currentStep, 'staff');
        }
        else{
          var newStaffToShow = (currentStaffIs.staff_id!==undefined) ? allDepartmentStaff[currStaffOrderNumber] : allDepartmentStaff[0];
          this.setState({ currentStaffDetail: newStaffToShow, showDepartmentJourneyScreen: false, showStaffJourneyScreen: true });
        }
        window.scrollTo(0,0);
    }


    advanceSurveyFrom(currentStep, requirements){

        if(requirements==='staff'){
            var strDepts = '';
            for (var i = this.state.savedSurvey.departments.length - 1; i >= 0; i--) {
                strDepts += this.state.savedSurvey.departments[i].key;
            }

            if(!this.staffCached()){
                this.props.getDeptStaff(this.props.tvClient, this.state.savedSurvey.departments).then((response)=> {
                    var newRequest = { 'depts': strDepts, 'staff': this.props.staffData };
                    var currStaffRequests = this.state.cachedStaffRequests;
                    currStaffRequests.push(newRequest);
                    this.setState({ cachedStaffRequests: currStaffRequests });
                });                
            }
            else{
                for (var z = this.state.cachedStaffRequests.length - 1; z >= 0; z--) {
                    if(this.state.cachedStaffRequests[z].depts === strDepts){
                        this.props.cachedResults(this.state.cachedStaffRequests[z].staff);
                    }
                }
            }

        } 

        this.setState({
            surveyData: this.findNextPage(),
            currentQuestion: this.state.currentQuestion+1
        });

        if(requirements!=="submit"){
            this.saveSurveyStatus();    
        }
        
    }


    backwardSurveyFrom(currentStep){
        if(this.props.surveyData.urlInfo[0].dept_list.length===1){
            let tempSurvey = this.findPreviousPage();
            tempSurvey.currentPage='page-2';

            this.setState({
                surveyData: tempSurvey,
                currentQuestion: this.state.currentQuestion-1,
                showNoStaffJourneyScreen: true
            });             
        } else{
        this.setState({
            surveyData: this.findPreviousPage(),
            npsValue: 0,
            currentQuestion: this.state.currentQuestion-1
        }); 
    }

    }

    trackReviewReferLink(param, ev){
        if(param==='refer' || param==='google' || param==='google-staff' || param==='healthgrades' || param==='facebook' || param==='yelp'){
            this.props.trackReviewReferClicks(this.props.tvClient,param,this.props.match.params.survey_url);
        }
    }

    changeLocale(ev, param){
        localizedData.setLanguage(param);
        this.setState({language: param});
    }

    openLanguageSwitcher(params, ev){
      document.querySelector('.language-switcher').classList.toggle('open');
      ev.stopPropagation();
    }

    selectLanguageOption(params, event){
      const languageSwitcher = document.querySelector('.language-switcher');
      const button = languageSwitcher.querySelector('.language-switcher__button');
      const selectedOption = event.target.closest('.language-switcher__option');
        if (selectedOption) {
            // Update button content with the selected flag and country code
            button.querySelector('.language-switcher__flag').src = selectedOption.querySelector('.language-switcher__flag').src;
            button.querySelector('.language-switcher__country-code').textContent = selectedOption.querySelector('.language-switcher__country-code').textContent;

            // Set the data-selected-language attribute on the parent div
            const language = selectedOption.getAttribute('data-language');
            languageSwitcher.setAttribute('data-selected-language', language);
            this.changeLocale(this, selectedOption.querySelector('.language-switcher__country-code').textContent)
            // Close the dropdown
            languageSwitcher.classList.remove('open');
        }
    }

    turntable = null;

    render() {
        return  <div className='uiHolder'>

      {this.props.surveyData && (this.state.fullyLoaded && this.props.surveyData.currentPage==="page-1") ?  <div> 

        <section className="nav">
            <div className="language-switcher">
                <button onClick={this.openLanguageSwitcher.bind(this, null)} className="language-switcher__button" aria-label="Change language">
                    <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                    <div className="language-switcher__country-code">EN</div>
                    <img className="language-switcher__arrow" src="/icons/chevron-down-small-white.svg" alt="Dropdown arrow" />
                </button>
                <div onClick={this.selectLanguageOption.bind(this, null)} className="language-switcher__select">
                    <button className="language-switcher__option" data-language="english" aria-label="Select English">
                        <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                        <div className="language-switcher__country-code">EN</div>
                    </button>
                    <button className="language-switcher__option" data-language="spanish" aria-label="Select Spanish">
                        <img className="language-switcher__flag" src="/flags/flag-es.svg" alt="Flag of Spain" />
                        <div className="language-switcher__country-code">ES</div>
                    </button>
                </div>
            </div>
      </section>     

      <section className="section main">
        <div className="container">
        {(this.props.surveyData.urlInfo[0].logo===null || this.props.surveyData.urlInfo[0].logo===undefined) ? <img alt="" className="client-logo"  aria-label="Logo" src="/newlogo.png" alt="Logo"/> : <img alt="" className="client-logo"  aria-label="Logo" src={this.props.surveyData.urlInfo[0].logo} alt="Logo"/>}
            <div className="copy-wrapper">
                <h1 className="page-heading">{localizedData.instruction_line_1}!</h1>
                <p>{localizedData.instruction_line_3}</p>
                <p>{localizedData.thank_you}</p>
            </div>

            {this.props.surveyData && (this.state.showNextButton) ? <button type="button" onClick={ (ev) => this.advanceDepartmentJourney(this)} className="btn"  aria-label="Button to continue to the next page">{localizedData.next}</button> : null }
        </div>
      </section>         
         
        <section className="section footer">
            <div className="container">
                <p className="powered-by-welliq">Powered by <a href="https://welliq.org/" target="_blank">Well iQ</a> — Your Voice Matters.</p>
            </div>
        </section>
       </div> : null
   }

{this.props.surveyData && (this.state.fullyLoaded && this.state.showNoStaffJourneyScreen) ?   <div>
      <section className="nav">
        {this.props.surveyData && !this.props.surveyData.firstPage ? <button onClick={this.backwardDepartmentJourney.bind(this, null)} className="back" aria-label="Go back">
            <img src="/icons/chevron-left-white.svg" className="back__arrow" alt="Back arrow" />
            <span>{localizedData.back}</span>
        </button> : null }
            <div className="language-switcher">
                <button onClick={this.openLanguageSwitcher.bind(this, null)} className="language-switcher__button" aria-label="Change language">
                    <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                    <div className="language-switcher__country-code">EN</div>
                    <img className="language-switcher__arrow" src="/icons/chevron-down-small-white.svg" alt="Dropdown arrow" />
                </button>
                <div onClick={this.selectLanguageOption.bind(this, null)} className="language-switcher__select">
                    <button className="language-switcher__option" data-language="english" aria-label="Select English">
                        <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                        <div className="language-switcher__country-code">EN</div>
                    </button>
                    <button className="language-switcher__option" data-language="spanish" aria-label="Select Spanish">
                        <img className="language-switcher__flag" src="/flags/flag-es.svg" alt="Flag of Spain" />
                        <div className="language-switcher__country-code">ES</div>
                    </button>
                </div>
            </div>
      </section>  
      <section className="hero relative">
        <div className="overlay blur"></div>
        <div className="container">
            <div className="hero__wrapper">
                <div className="hero__image-wrapper">
                    <img src={this.state.currentDeptDetail.icon.startsWith('http') ? this.state.currentDeptDetail.icon : process.env.PUBLIC_URL + '/department_assets/' + this.state.currentDeptDetail.icon} alt={this.localizeDepartment(this.state.currentDeptDetail)} className="hero__img" />
                </div>
                <div className="hero__content-wrapper">
                    <h1 className="hero__title">{this.localizeDepartment(this.state.currentDeptDetail)}</h1>
                </div>
            </div>
        </div>
        <svg className="hero-divider" xmlns="http://www.w3.org/2000/svg" width="393" height="16" viewBox="0 0 393 16" fill="none">
            <path d="M393 16H0V0C131 17.92 262 17.92 393 0V16Z" fill="white"/>
        </svg>
    </section>
    
    <section className="form-feedback-section">
        <div className="container form-feedback-container">
            <div className="form-feedbak-wrapper">
                <div className="form" aria-label="Feedback Form">
                    <div className="form-content-wrapper">
                        <label htmlFor="feedback-input-dept" className="text-title--m text-color--primary">{this.localizeDepartment(this.state.currentDeptDetail)}</label>
                        <textarea id="feedback-input-dept" onChange={this.handleDeptFeedbackChange.bind(this)} value={this.state.currentDeptDetail.feedback!==undefined ? this.state.currentDeptDetail.feedback : ''}  name="feedback" placeholder={localizedData.feedback_placeholder} rows="4" aria-required="true"></textarea>
                    </div>
                    
                    <div className="form-content-wrapper">
                        <div className="title-wrapper">
                            <h2 className="text-title--m text-color--primary">{localizedData.choose_badges} <span className="extraInfo">( {localizedData.scroll_for_more} )</span></h2>
                        </div>
                        <div className="badge-cards">

                        {
                        this.props.surveyData.deptEndorsements.map(c => {
                          if(c.department!==undefined && c.department!==null && c.department!=='' && (c.department.toString()!==this.state.currentDeptDetail.key.toString())){
                            return;
                          } else {

                            var localeValue = localizedData[c.localization_key];
                            var severity = false;
                            var localeDescriptor = localizedData.chooseRatingBelow;
                            if(c.localization_options!==undefined && c.localization_options!==null){
                              let tempValue = c.localization_options[this.state.language];
                              if(tempValue!==undefined){
                                localeValue = tempValue;
                              }

                              let severityOption = c.localization_options['severity'];
                              if(severityOption!==undefined){
                                severity = true;
                              }

                              let tempDescriptor = c.localization_options['descriptor_'+this.state.language];
                              if(tempDescriptor!==undefined){
                                localeDescriptor = tempDescriptor;
                              }

                            }

                            if(severity){
                              return  <label htmlFor={c.endorsement_id} className={""+ 'badge-card severity ' + (this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'addCheckMark' : '')} key={c.endorsement_id}>
                              <div className="badge-card__col-wrapper severity">
                                  <div className="badge-card__icon-wrapper-survey">
                                      <img className="badge-card__icon" src={c.image.startsWith('http') ? c.image : process.env.PUBLIC_URL + '/endorsement_assets/' + c.image} alt={localeValue + " icon"} />
                                      <div className={""+'badge-card__icon-overlay-survey ' + (this.generateSeverityName(c,this.state.currentDeptDetail))}></div>
                                  </div>
                                  <div className="badge-card__content-wrapper">
                                      <h3 className="badge-card__title">{localeValue}</h3>
                                      <p className={""+'badge-card__rating-text ' + (this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'hidden' : '')}>{localeDescriptor}</p>
                                      <a onClick={(ev) => this.openSeverityDrawer(ev) } className={""+'badge-card__rating-text-link ' + (!this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'hidden' : '')}>Change this rating</a>
                                  </div>
                              </div>
                              <div className={"" + 'badge-card__ratings ' + (this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'closed' : '') }>
                                  <div className="badge-card__rating-links">
                                    <a onClick={(ev) => this.chooseSeverityDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link bad ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Bad") ? 'activeDept' : '') }>{localizedData.severityBad}</a>
                                    <a onClick={(ev) => this.chooseSeverityDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link average ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Average") ? 'activeDept' : '')}>{localizedData.severityOkay}</a>
                                    <a onClick={(ev) => this.chooseSeverityDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link good ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Great") ? 'activeDept' : '')}>{localizedData.severityGreat}</a>
                                  </div>
                              </div>
                              

                              </label>

                            } else{

                            return  <label htmlFor={c.endorsement_id} className={""+ 'badge-card ' + (this.generateClassNames(c, this.state.currentDeptDetail) ? 'addCheckMark' : '')} key={c.endorsement_id}>
                                <div className="badge-card__col-wrapper">
                                    <div className="badge-card__icon-wrapper-survey">
                                        <img className="badge-card__icon" src={c.image.startsWith('http') ? c.image : process.env.PUBLIC_URL + '/endorsement_assets/' + c.image} alt={localeValue + " icon"} />
                                    </div>
                                    <div className="badge-card__content-wrapper">
                                        <h3 className="badge-card__title">{localeValue}</h3>
                                    </div>
                                </div>
                                <input type="checkbox" defaultChecked={"" + (this.generateClassNames(c, this.state.currentDeptDetail) ? ' checked=checked' : '')} onClick={(ev) => this.chooseDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} />
                                </label>
                            }
                          }
                          
                        })
                    }      


                        </div>
                    </div>
                </div>
            </div>              
        </div>
    </section>

    <section className="section footer">
            <div className="container">
                <p className="powered-by-welliq">Powered by <a href="https://welliq.org/" target="_blank">Well iQ</a> — Your Voice Matters.</p>
            </div>
        </section>

        <section className="btn-sticky" >
          <div className="container">
             <a onClick={this.advanceDepartmentJourney.bind(this)} id="continue-btn" className="btn" aria-label="Button to continue to the next page">{localizedData.next}</a> 
          </div>
      </section>

      </div> : null
   }



      {this.props.surveyData && (this.state.fullyLoaded && this.state.showDepartmentJourneyScreen) ?  <div> 
        <section className="nav">
        {this.props.surveyData && !this.props.surveyData.firstPage ? <button onClick={this.backwardDepartmentJourney.bind(this, null)} className="back" aria-label="Go back">
            <img src="/icons/chevron-left-white.svg" className="back__arrow" alt="Back arrow" />
            <span>{localizedData.back}</span>
        </button> : null }
            <div className="language-switcher">
                <button onClick={this.openLanguageSwitcher.bind(this, null)} className="language-switcher__button" aria-label="Change language">
                    <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                    <div className="language-switcher__country-code">EN</div>
                    <img className="language-switcher__arrow" src="/icons/chevron-down-small-white.svg" alt="Dropdown arrow" />
                </button>
                <div onClick={this.selectLanguageOption.bind(this, null)} className="language-switcher__select">
                    <button className="language-switcher__option" data-language="english" aria-label="Select English">
                        <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                        <div className="language-switcher__country-code">EN</div>
                    </button>
                    <button className="language-switcher__option" data-language="spanish" aria-label="Select Spanish">
                        <img className="language-switcher__flag" src="/flags/flag-es.svg" alt="Flag of Spain" />
                        <div className="language-switcher__country-code">ES</div>
                    </button>
                </div>
            </div>
      </section>  
      <section>
          <div className="container">
              <div className="form">
                  <div className="form-content-wrapper center-all">
                      <label className="page-heading">{this.localizeDepartment(this.state.currentDeptStaffList.details)}</label>
                      <p>{localizedData[this.props.surveyData.questionInfo[this.state.currentQuestion].page_id]}</p>
                  </div>
                  <div className="staff-grid">
                    { (this.state.currentDeptStaffList!==null) && this.state.currentDeptStaffList.map(c => {
                      
                        return <label htmlFor={c.staff_id} className={"staff-card "  + (this.isStaffSelected(c.staff_id) ? 'activeDept' : '' )} key={c.staff_id}>
                                <img src={c.staffimageid.startsWith('http') ? c.staffimageid : process.env.PUBLIC_URL + '/staff_assets/' + c.staffimageid} alt={c.name} className="staff-card__img" />
                                <h3 htmlFor={c.staff_id} className="text-title--xs text-color--primary staff-card__name">{c.name}</h3>
                                <input type="checkbox" defaultChecked={"" + (this.isStaffSelected(c.staff_id) ? 'checked=checked' : '' )} onClick={(ev) => this.chooseStaff(c, ev) } id={c.staff_id} name={c.name} value={c.staff_id} />
                            </label>
                                      
                    })}

                            <label className="staff-card" key='notsureaboutit' onClick={ (ev) => this.advanceStaffEndorsementsJourney(this, 'first') } >
                                <img alt="I'm not sure" src={process.env.PUBLIC_URL + '/unknown-employee.png'} className="staff-card__img" />
                                <h3 className="text-title--xs text-color--primary staff-card__name">{localizedData.notsure}</h3>
                            </label>

                   </div>  
              </div>
          </div>
      </section>

      <section className="section footer">
            <div className="container">
                <p className="powered-by-welliq">Powered by <a href="https://welliq.org/" target="_blank">Well iQ</a> — Your Voice Matters.</p>
            </div>
        </section>

        <section className="btn-sticky" >
          <div className="container">
              <a onClick={ (ev) => this.advanceStaffEndorsementsJourney(this, 'first')} id="continue-btn" className="btn" aria-label="Button to continue to the next page">{localizedData.next}</a>
          </div>
      </section>

      </div> : null
   }

{this.props.surveyData && (this.state.showStaffJourneyScreen && this.state.fullyLoaded) ?   <div> 
      <section className="nav">
        {this.props.surveyData && !this.props.surveyData.firstPage ? <button onClick={this.backwardStaffEndorsementJourney.bind(this, null)} className="back" aria-label="Go back">
            <img src="/icons/chevron-left-white.svg" className="back__arrow" alt="Back arrow" />
            <span>{localizedData.back}</span>
        </button> : null }
            <div className="language-switcher">
                <button onClick={this.openLanguageSwitcher.bind(this, null)} className="language-switcher__button" aria-label="Change language">
                    <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                    <div className="language-switcher__country-code">EN</div>
                    <img className="language-switcher__arrow" src="/icons/chevron-down-small-white.svg" alt="Dropdown arrow" />
                </button>
                <div onClick={this.selectLanguageOption.bind(this, null)} className="language-switcher__select">
                    <button className="language-switcher__option" data-language="english" aria-label="Select English">
                        <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                        <div className="language-switcher__country-code">EN</div>
                    </button>
                    <button className="language-switcher__option" data-language="spanish" aria-label="Select Spanish">
                        <img className="language-switcher__flag" src="/flags/flag-es.svg" alt="Flag of Spain" />
                        <div className="language-switcher__country-code">ES</div>
                    </button>
                </div>
            </div>
      </section>  
      <section className="hero relative">
        <div className="overlay blur"></div>
        <div className="container">
            <div className="hero__wrapper">
                <div className="hero__image-wrapper">
                    <img src={this.state.currentStaffDetail.staffimageid.startsWith('http') ? this.state.currentStaffDetail.staffimageid : process.env.PUBLIC_URL + '/staff_assets/' + this.state.currentStaffDetail.staffimageid} alt={(this.state.currentStaffDetail.name) + " Headshot"} className="hero__img" />
                </div>
                <div className="hero__content-wrapper">
                    <h1 className="hero__title">{this.state.currentStaffDetail.name}</h1>
                    <p className="hero__position">{this.state.currentStaffDetail.title}</p> 
                </div>
            </div>
        </div>
        <svg className="hero-divider" xmlns="http://www.w3.org/2000/svg" width="393" height="16" viewBox="0 0 393 16" fill="none">
            <path d="M393 16H0V0C131 17.92 262 17.92 393 0V16Z" fill="white"/>
        </svg>
    </section>
    
    <section className="form-feedback-section">
        <div className="container form-feedback-container">
            <div className="form-feedbak-wrapper">
                <div className="form" aria-label="Feedback Form">
                    <div className="form-content-wrapper">
                        <label htmlFor="feedback-input" className="text-title--m text-color--primary">{localizedData.formatString(localizedData.how_did, this.state.currentStaffDetail.name)}</label>
                        <textarea id="feedback-input" onChange={this.handleStaffFeedbackChange.bind(this)} value={this.state.currentStaffDetail.feedback!==undefined ? this.state.currentStaffDetail.feedback : ''} name="feedback" placeholder={localizedData.feedback_placeholder} rows="4" aria-required="true"></textarea>
                    </div>
                    
                    <div className="form-content-wrapper">
                        <div className="title-wrapper">
                            <h2 className="text-title--m text-color--primary">{localizedData.choose_badges} <span className="extraInfo">( {localizedData.scroll_for_more} )</span></h2>
                        </div>
                        <div className="badge-cards">

                        {
                        this.props.surveyData.staffEndorsements.map(c => {
                          if(c.department!==undefined && c.department!==null && c.department!=='' && (c.department.toString()!==this.state.currentStaffDetail.department_id.toString())){
                            return;
                          } else {
                            
                            var localeValue = localizedData[c.localization_key];
                            var severity = false;
                            var localeDescriptor = localizedData.chooseRatingBelow;
                            if(c.localization_options!==undefined && c.localization_options!==null){
                              let tempValue = c.localization_options[this.state.language];
                              if(tempValue!==undefined){
                                localeValue = tempValue;
                              }

                              let severityOption = c.localization_options['severity'];
                              if(severityOption!==undefined){
                                severity = true;
                              }
                              
                              let tempDescriptor = c.localization_options['descriptor_'+this.state.language];
                              if(tempDescriptor!==undefined){
                                localeDescriptor = tempDescriptor;
                              }
                            }

                            if(severity){

                              return  <label htmlFor={c.endorsement_id} className={""+ 'badge-card severity ' + (this.generateSeveritySelected(c, this.state.currentStaffDetail) ? 'addCheckMark' : '')} key={c.endorsement_id}>
                              <div className="badge-card__col-wrapper severity">
                                  <div className="badge-card__icon-wrapper-survey">
                                      <img className="badge-card__icon" src={c.image.startsWith('http') ? c.image : process.env.PUBLIC_URL + '/endorsement_assets/' + c.image} alt={localeValue + " icon"} />
                                      <div className={""+'badge-card__icon-overlay-survey ' + (this.generateSeverityName(c,this.state.currentStaffDetail))}></div>
                                  </div>
                                  <div className="badge-card__content-wrapper">
                                      <h3 className="badge-card__title">{localeValue}</h3>
                                      <p className={""+'badge-card__rating-text ' + (this.generateSeveritySelected(c, this.state.currentStaffDetail) ? 'hidden' : '')}>{localeDescriptor}</p>
                                      <a onClick={(ev) => this.openSeverityDrawer(ev) } className={""+'badge-card__rating-text-link ' + (!this.generateSeveritySelected(c, this.state.currentStaffDetail) ? 'hidden' : '')}>Change this rating</a>
                                  </div>
                              </div>
                              <div className={"" + 'badge-card__ratings ' + (this.generateSeveritySelected(c, this.state.currentStaffDetail) ? 'closed' : '') }>
                                  <div className="badge-card__rating-links">
                                    <a onClick={(ev) => this.chooseSeverityStaffEndorsement(c, this.state.currentStaffDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link bad ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Bad") ? 'activeDept' : '') }>{localizedData.severityBad}</a>
                                    <a onClick={(ev) => this.chooseSeverityStaffEndorsement(c, this.state.currentStaffDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link average ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Average") ? 'activeDept' : '')}>{localizedData.severityOkay}</a>
                                    <a onClick={(ev) => this.chooseSeverityStaffEndorsement(c, this.state.currentStaffDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link good ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Great") ? 'activeDept' : '')}>{localizedData.severityGreat}</a>
                                  </div>
                              </div>
                              

                              </label>
                              

                            } else {

                                return  <label htmlFor={c.endorsement_id} className={""+ 'badge-card ' + (this.generateClassNames(c, this.state.currentStaffDetail) ? 'addCheckMark' : '')} key={c.endorsement_id}>
                                <div className="badge-card__col-wrapper">
                                    <div className="badge-card__icon-wrapper-survey">
                                        <img className="badge-card__icon" src={c.image.startsWith('http') ? c.image : process.env.PUBLIC_URL + '/endorsement_assets/' + c.image} alt={localeValue + " icon"} />
                                    </div>
                                    <div className="badge-card__content-wrapper">
                                        <h3 className="badge-card__title">{localeValue}</h3>
                                    </div>
                                </div>
                                <input type="checkbox" defaultChecked={"" + (this.generateClassNames(c, this.state.currentStaffDetail) ? 'checked=checked' : '')} onClick={(ev) => this.chooseStaffEndorsement(c, this.state.currentStaffDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} />
                                </label>
                              }

                          }
                          
                        })
                    }      


                        </div>
                    </div>
                </div>
            </div>              
        </div>
    </section>

    <section className="section footer">
            <div className="container">
                <p className="powered-by-welliq">Powered by <a href="https://welliq.org/" target="_blank">Well iQ</a> — Your Voice Matters.</p>
            </div>
        </section>

        <section className="btn-sticky" >
          <div className="container">
              <a onClick={ (ev) => this.advanceStaffEndorsementsJourney(this, null)} id="continue-btn" className="btn" aria-label="Button to continue to the next page">{localizedData.next}</a>
          </div>
      </section>

      </div> : null
   }

    {this.props.surveyData && (this.state.fullyLoaded && this.props.surveyData.currentPage==="page-3") ?   <div>
      <section className="nav">
        {this.props.surveyData && !this.props.surveyData.firstPage ? <button onClick={(ev) => this.backwardStaffEndorsementJourney(this, 'facility')} className="back" aria-label="Go back">
            <img src="/icons/chevron-left-white.svg" className="back__arrow" alt="Back arrow" />
            <span>{localizedData.back}</span>
        </button> : null }
            <div className="language-switcher">
                <button onClick={this.openLanguageSwitcher.bind(this, null)} className="language-switcher__button" aria-label="Change language">
                    <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                    <div className="language-switcher__country-code">EN</div>
                    <img className="language-switcher__arrow" src="/icons/chevron-down-small-white.svg" alt="Dropdown arrow" />
                </button>
                <div onClick={this.selectLanguageOption.bind(this, null)} className="language-switcher__select">
                    <button className="language-switcher__option" data-language="english" aria-label="Select English">
                        <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                        <div className="language-switcher__country-code">EN</div>
                    </button>
                    <button className="language-switcher__option" data-language="spanish" aria-label="Select Spanish">
                        <img className="language-switcher__flag" src="/flags/flag-es.svg" alt="Flag of Spain" />
                        <div className="language-switcher__country-code">ES</div>
                    </button>
                </div>
            </div>
      </section>  
      <section className="hero relative">
        <div className="overlay blur"></div>
        <div className="container">
            <div className="hero__wrapper">
                <div className="hero__image-wrapper">
                    <img src={this.state.currentDeptDetail.icon.startsWith('http') ? this.state.currentDeptDetail.icon : process.env.PUBLIC_URL + '/department_assets/' + this.state.currentDeptDetail.icon} alt={this.localizeDepartment(this.state.currentDeptDetail)} className="hero__img" />
                </div>
                <div className="hero__content-wrapper">
                    <h1 className="hero__title">{this.localizeDepartment(this.state.currentDeptDetail)}</h1>
                </div>
            </div>
        </div>
        <svg className="hero-divider" xmlns="http://www.w3.org/2000/svg" width="393" height="16" viewBox="0 0 393 16" fill="none">
            <path d="M393 16H0V0C131 17.92 262 17.92 393 0V16Z" fill="white"/>
        </svg>
    </section>
    
    <section className="form-feedback-section">
        <div className="container form-feedback-container">
            <div className="form-feedbak-wrapper">
                <div className="form" aria-label="Feedback Form">
                    <div className="form-content-wrapper">
                        <label htmlFor="feedback-input-dept" className="text-title--m text-color--primary">{this.localizeDepartment(this.state.currentDeptDetail)}</label>
                        <textarea id="feedback-input-dept" onChange={this.handleDeptFeedbackChange.bind(this)} value={this.state.currentDeptDetail.feedback!==undefined ? this.state.currentDeptDetail.feedback : ''}  name="feedback" placeholder={localizedData.feedback_placeholder} rows="4" aria-required="true"></textarea>
                    </div>
                    
                    <div className="form-content-wrapper">
                        <div className="title-wrapper">
                            <h2 className="text-title--m text-color--primary">{localizedData.choose_badges} <span className="extraInfo">( {localizedData.scroll_for_more} )</span></h2>
                        </div>
                        <div className="badge-cards">

                        {
                        this.props.surveyData.deptEndorsements.map(c => {
                          if(c.department!==undefined && c.department!==null && c.department!=='' && (c.department.toString()!==this.state.currentDeptDetail.key.toString())){
                            return;
                          } else {

                            var localeValue = localizedData[c.localization_key];
                            var severity = false;
                            var localeDescriptor = localizedData.chooseRatingBelow;
                            if(c.localization_options!==undefined && c.localization_options!==null){
                              let tempValue = c.localization_options[this.state.language];
                              if(tempValue!==undefined){
                                localeValue = tempValue;
                              }

                              let severityOption = c.localization_options['severity'];
                              if(severityOption!==undefined){
                                severity = true;
                              }
                                                            
                              let tempDescriptor = c.localization_options['descriptor_'+this.state.language];
                              if(tempDescriptor!==undefined){
                                localeDescriptor = tempDescriptor;
                              }
                            }

                            if(severity){
                              return  <label htmlFor={c.endorsement_id} className={""+ 'badge-card severity ' + (this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'addCheckMark' : '')} key={c.endorsement_id}>
                              <div className="badge-card__col-wrapper severity">
                                  <div className="badge-card__icon-wrapper-survey">
                                      <img className="badge-card__icon" src={c.image.startsWith('http') ? c.image : process.env.PUBLIC_URL + '/endorsement_assets/' + c.image} alt={localeValue + " icon"} />
                                      <div className={""+'badge-card__icon-overlay-survey ' + (this.generateSeverityName(c,this.state.currentDeptDetail))}></div>
                                  </div>
                                  <div className="badge-card__content-wrapper">
                                      <h3 className="badge-card__title">{localeValue}</h3>
                                      <p className={""+'badge-card__rating-text ' + (this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'hidden' : '')}>{localeDescriptor}</p>
                                      <a onClick={(ev) => this.openSeverityDrawer(ev) } className={""+'badge-card__rating-text-link ' + (!this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'hidden' : '')}>Change this rating</a>
                                  </div>
                              </div>
                              <div className={"" + 'badge-card__ratings ' + (this.generateSeveritySelected(c, this.state.currentDeptDetail) ? 'closed' : '') }>
                                  <div className="badge-card__rating-links">
                                    <a onClick={(ev) => this.chooseSeverityDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link bad ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Bad") ? 'activeDept' : '') }>{localizedData.severityBad}</a>
                                    <a onClick={(ev) => this.chooseSeverityDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link average ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Average") ? 'activeDept' : '')}>{localizedData.severityOkay}</a>
                                    <a onClick={(ev) => this.chooseSeverityDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} className={"" + 'badge-card__rating-link good ' + (this.generateSeverityClassNames(c, this.state.currentStaffDetail, "Great") ? 'activeDept' : '')}>{localizedData.severityGreat}</a>
                                  </div>
                              </div>
                              

                              </label>

                            } else{

                            return  <label htmlFor={c.endorsement_id} className={""+ 'badge-card ' + (this.generateClassNames(c, this.state.currentDeptDetail) ? 'addCheckMark' : '')} key={c.endorsement_id}>
                                <div className="badge-card__col-wrapper">
                                    <div className="badge-card__icon-wrapper-survey">
                                        <img className="badge-card__icon" src={c.image.startsWith('http') ? c.image : process.env.PUBLIC_URL + '/endorsement_assets/' + c.image} alt={localeValue + " icon"} />
                                    </div>
                                    <div className="badge-card__content-wrapper">
                                        <h3 className="badge-card__title">{localeValue}</h3>
                                    </div>
                                </div>
                                <input type="checkbox" defaultChecked={"" + (this.generateClassNames(c, this.state.currentDeptDetail) ? ' checked=checked' : '')} onClick={(ev) => this.chooseDepartmentEndorsement(c, this.state.currentDeptDetail, ev) } id={c.endorsement_id} name={localeValue} value={c.endorsement_id} />
                                </label>
                            }
                          }
                          
                        })
                    }      


                        </div>
                    </div>
                </div>
            </div>              
        </div>
    </section>

    <section className="section footer">
            <div className="container">
                <p className="powered-by-welliq">Powered by <a href="https://welliq.org/" target="_blank">Well iQ</a> — Your Voice Matters.</p>
            </div>
        </section>

        <section className="btn-sticky" >
          <div className="container">
              <a onClick={this.advanceSurveyFrom.bind(this)} id="continue-btn" className="btn" aria-label="Button to continue to the next page">{localizedData.next}</a>
          </div>
      </section>

      </div> : null
   }

      {this.props.surveyData && (this.state.fullyLoaded && this.props.surveyData.currentPage==="page-4") ?  <div> 
        <section className="nav">
        {this.props.surveyData && !this.props.surveyData.firstPage ? <button onClick={ this.backwardSurveyFrom.bind(this) } className="back" aria-label="Go back">
            <img src="/icons/chevron-left-white.svg" className="back__arrow" alt="Back arrow" />
            <span>{localizedData.back}</span>
        </button> : null }
            <div className="language-switcher">
                <button onClick={this.openLanguageSwitcher.bind(this, null)} className="language-switcher__button" aria-label="Change language">
                    <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                    <div className="language-switcher__country-code">EN</div>
                    <img className="language-switcher__arrow" src="/icons/chevron-down-small-white.svg" alt="Dropdown arrow" />
                </button>
                <div onClick={this.selectLanguageOption.bind(this, null)} className="language-switcher__select">
                    <button className="language-switcher__option" data-language="english" aria-label="Select English">
                        <img className="language-switcher__flag" src="/flags/flag-us.svg" alt="Flag of the United States" />
                        <div className="language-switcher__country-code">EN</div>
                    </button>
                    <button className="language-switcher__option" data-language="spanish" aria-label="Select Spanish">
                        <img className="language-switcher__flag" src="/flags/flag-es.svg" alt="Flag of Spain" />
                        <div className="language-switcher__country-code">ES</div>
                    </button>
                </div>
            </div>
      </section>  
        
      <section>
      <div className="container center-all">
            <h1 className="page-heading">{localizedData[this.props.surveyData.questionInfo[this.state.currentQuestion].page_id]}</h1>
            <div className="rating five-points">
                <button onClick={this.handleNpsClick.bind(this, 1)} className="rating__point" data-value="1" aria-label="Rate 1 star"></button>
                <button onClick={this.handleNpsClick.bind(this, 2)} className="rating__point" data-value="2" aria-label="Rate 2 stars"></button>
                <button onClick={this.handleNpsClick.bind(this, 3)} className="rating__point" data-value="3" aria-label="Rate 3 stars"></button>
                <button onClick={this.handleNpsClick.bind(this, 4)} className="rating__point" data-value="4" aria-label="Rate 4 stars"></button>
                <button onClick={this.handleNpsClick.bind(this, 5)} className="rating__point" data-value="5" aria-label="Rate 5 stars"></button>
            </div>
            <div className="row cardInstructions"><p>{localizedData.nps_choose}</p></div>  
            <button disabled={(this.state.npsValue===0) ? 'disabled' : ''} onClick={this.handleNpsClick.bind(this, 0)} className="btn" aria-label="Send form button">Submit</button>
        </div>

        <Modal size="sm" show={this.state.confirmOpen} onHide={this.handleClose.bind(this)}>
          <Modal.Header className="modalPadding" >
            <Modal.Title>{localizedData.confirmRating}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{localizedData.confirmSentence}<b>{this.state.confirmRating}</b>{localizedData.confirmSentenceTwo}5?</Modal.Body>
          <Modal.Footer>
            <Button  onClick={this.handleClose.bind(this)}>
              {localizedData.confirmNo}
            </Button>
            <Button onClick={this.handleConfirm.bind(this)}>
              {localizedData.confirmYes}
            </Button>
          </Modal.Footer>
        </Modal>  

    </section>
        

          
          <section className="section footer">
            <div className="container">
                <p className="powered-by-welliq">Powered by <a href="https://welliq.org/" target="_blank">Well iQ</a> — Your Voice Matters.</p>
            </div>
        </section>
       </div> : null
   }

{this.props.surveyData && (this.props.surveyData.currentPage==="page-5" && this.state.fullyLoaded && !this.state.showReviewPage && !this.state.completedSurvey) ?   <div> 
  <section className="nav">
  <p>{process.env.CLIENT_NAME}</p>
      </section>  
      <section className="section">
      <h1 className="page-heading center-all">{localizedData.spinWheel}</h1> 
           <div className="prizeSpinContainer center-all">
            <div className="prizeTicker"/>
            <ReactTurntable {...this.state.options} hiddenButton 
            onStart={this.startPrizeDrawing.bind(this)} 
            onComplete={this.finishPrizeDrawing.bind(this)} 
            getTurntable={turntable => (this.turntable = turntable)}/>
            <div className="container">
          <button  disabled={(this.turntable!==null) ? 'disabled' : ''} onClick={() => this.turntable.start()} className="btn" aria-label="Send form button">Spin the wheel!</button>
          </div>
          </div>

          
          <a className="ruleLink hidden hide"  target="_blank">{localizedData.viewrules}</a>       
       </section></div> : null
   }

 {this.props.surveyData && (this.props.surveyData.currentPage==="page-5" && this.state.fullyLoaded && this.state.showReviewPage && (this.state.savedSurvey.nps===4 || this.state.savedSurvey.nps===5 || this.state.savedSurvey.nps==='4' || this.state.savedSurvey.nps==='5'))  ?   <div>
  <section className="nav">
  <p>{process.env.CLIENT_NAME}</p>
      </section>  
  <section className="section center-all">

        {this.state.prizeWinnings && <p className="page-heading center-all">{this.state.prizeWinnings}</p> }

          {(!this.props.surveyData.urlInfo[0].google_id && !this.props.surveyData.urlInfo[0].yelp_id && !this.props.surveyData.urlInfo[0].facebook_id && !this.props.surveyData.urlInfo[0].healthgrades) && <h5 className="surveyPageTitle">{localizedData.thank_you}</h5>}
          {(this.props.surveyData.urlInfo[0].google_id || this.props.surveyData.urlInfo[0].yelp_id || this.props.surveyData.urlInfo[0].facebook_id || this.props.surveyData.urlInfo[0].healthgrades) && <p className="surveyPageInstruction text-center">{localizedData.reviewPromptText}</p>}
          {
                        this.state.savedSurvey.staff.map(c => {
                          if(c.reviews!==undefined && c.reviews!==null && c.reviews.google!==undefined && c.reviews.google!==null){
                            return <div key={c.staff_id} className="reviewPageAlignCenter">
                              <div className="menu">
                                <p className="centerLocationText">{localizedData.formatString(localizedData.review_on_google, c.name)}</p>
                              </div>
                              <div className="col-md-12 center-all">
                                <label className="badge-checkbox float-left staffList">
                                  <img alt={c.name} className={"img-responsive"} src={c.staffimageid.startsWith('http') ? c.staffimageid : process.env.PUBLIC_URL + '/staff_assets/' + c.staffimageid} />
                                </label>
                                <a onTouchStart={this.trackReviewReferLink.bind(this, 'google-staff')} href={'https://search.google.com/local/writereview?placeid=' + c.reviews.google} className="float-left maxWidthStaffGoogle" ><img alt="Google Reviews" src="./google-reviews.png" /></a>
                              </div>
                              
                            </div>
                          } else {
                            return;
                          }
                        })
          }

 {((this.props.surveyData.urlInfo[0].google_id || this.props.surveyData.urlInfo[0].yelp_id || this.props.surveyData.urlInfo[0].facebook_id || this.props.surveyData.urlInfo[0].healthgrades) && this.state.showLocationBar ) && <div className="menu"><p className="centerLocationText">{localizedData.review_our_location}</p></div>}
          {this.props.surveyData.urlInfo[0].google_id && <a onTouchStart={this.trackReviewReferLink.bind(this, 'google')} onClick={this.trackReviewReferLink.bind(this, 'google')} href={'https://search.google.com/local/writereview?placeid=' + this.props.surveyData.urlInfo[0].google_id} className="reviewSite" ><img alt="Google Reviews" src="./google-reviews.png" /></a>}
          {this.props.surveyData.urlInfo[0].yelp_id &&  <a onTouchStart={this.trackReviewReferLink.bind(this, 'yelp')} onClick={this.trackReviewReferLink.bind(this, 'yelp')} href={this.props.surveyData.urlInfo[0].yelp_id} className="reviewSite" ><img alt="" src="./yelp_fullcolor.png" /></a> }
          {this.props.surveyData.urlInfo[0].facebook_id &&  <a onTouchStart={this.trackReviewReferLink.bind(this, 'facebook')} onClick={this.trackReviewReferLink.bind(this, 'facebook')} href={this.props.surveyData.urlInfo[0].facebook_id} className="reviewSite" ><img alt="" src="./facebook.jpg" /></a> }
          {this.props.surveyData.urlInfo[0].healthgrades &&  <a onTouchStart={this.trackReviewReferLink.bind(this, 'healthgrades')} onClick={this.trackReviewReferLink.bind(this, 'healthgrades')} href={this.props.surveyData.urlInfo[0].healthgrades} className="reviewSite" ><img alt="" src="./healthgrades.jpg" /></a> }  
       </section>

       {this.props.surveyData?.journeyInfo?.[0]?.name?.startsWith("QR Code") ? <SaveRecipientDataForm surveyUrl={this.props.match.params.survey_url} /> : null }


       </div> : null
   }


 {this.props.surveyData && (this.props.surveyData.currentPage==="page-5" && this.state.fullyLoaded && this.state.showReviewPage && (this.state.savedSurvey.nps===1 || this.state.savedSurvey.nps===2 || this.state.savedSurvey.nps===3 || this.state.savedSurvey.nps==='1' || this.state.savedSurvey.nps==='2' || this.state.savedSurvey.nps==='3')) ?   <div> 
  <section className="nav">
  <p>{process.env.CLIENT_NAME}</p>
      </section> 
  <div className="row text-center">
 {(this.props.surveyData.urlInfo[0].logo===null || this.props.surveyData.urlInfo[0].logo===undefined) ? <img className="inSurveyLogo" src="/newlogo.png" alt="Logo"/> : <img className="inSurveyLogo" src={this.props.surveyData.urlInfo[0].logo} alt="Logo"/>}
          <h5 className="surveyPageTitle mt-0">{localizedData.completed_survey}</h5> 
          {this.state.prizeWinnings && <h5 className="surveyPrizeWinnings">{this.state.prizeWinnings}</h5> }
          {(this.props.surveyData.urlInfo[0].google_id || this.props.surveyData.urlInfo[0].yelp_id || this.props.surveyData.urlInfo[0].facebook_id || this.props.surveyData.urlInfo[0].healthgrades) && <p className="surveyPageInstruction externalSurveyLinks beforeExternalLinks text-center poorReviewText">{localizedData.reviewPromptTextLower} {this.props.surveyData.urlInfo[0].google_id && <a onClick={this.trackReviewReferLink.bind(this, 'google')} href={'https://search.google.com/local/writereview?placeid=' + this.props.surveyData.urlInfo[0].google_id} className="reviewSite" >Google Reviews</a>}  {this.props.surveyData.urlInfo[0].yelp_id &&  <a href={this.props.surveyData.urlInfo[0].yelp_id} className="reviewSite" >Yelp! Reviews</a>  } {this.props.surveyData.urlInfo[0].facebook_id &&   <a href={this.props.surveyData.urlInfo[0].facebook_id} className="reviewSite" >Facebook Reviews</a> } {this.props.surveyData.urlInfo[0].healthgrades &&   <a href={this.props.surveyData.urlInfo[0].healthgrades} className="reviewSite" >HealthGrades</a> }</p>}  
          {this.props.surveyData?.journeyInfo?.[0]?.name?.startsWith("QR Code") ? <SaveRecipientDataForm surveyUrl={this.props.match.params.survey_url} /> : null } 
       </div></div> : null
   }

 {this.props.surveyData && (this.state.completedSurvey) ?   <div> 
  <section className="nav"></section>
  <div className="row cardholder serveSurvey">
          {(this.props.surveyData.urlInfo[0].logo===null || this.props.surveyData.urlInfo[0].logo===undefined) ? <img className="inSurveyLogo" src="/newlogo.png" alt="Logo"/> : <img className="inSurveyLogo" src={this.props.surveyData.urlInfo[0].logo} alt="Logo"/>}
          <h5 className="surveyPageTitle">{localizedData.completed_survey}</h5> 
          {this.state.prizeWinnings && <h5 className="surveyPrizeWinnings">{localizedData.you_won} {this.state.prizeWinnings}</h5> }
       </div></div> : null
   }

 {this.props.surveyData && (this.state.notYourSurvey && !this.state.restartedSurvey) ?   <div> 
  <section className="nav"></section>
  <div className="row cardholder serveSurvey">
          {(this.props.surveyData.urlInfo[0].logo===null || this.props.surveyData.urlInfo[0].logo===undefined) ? <img className="inSurveyLogo" src="/newlogo.png" alt="Logo"/> : <img className="inSurveyLogo" src={this.props.surveyData.urlInfo[0].logo} alt="Logo"/>}
          <h5 className="surveyPageTitle">{localizedData.another_device}</h5> 
          <br/>
          <button className="btn btn-primary centerButton" onClick={this.restartSurvey.bind(this)}>{localizedData.start}</button>
       </div></div> : null
   }

    </div>

    }
}

const mapStateToProps = (state) => {
    return {
        surveyData: state.survey.surveyData,
        existingSurvey: state.survey.existingSurvey,
        tvClient: state.login.tvClient,
        staffData: state.staff.staffData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      surveyBegin: (...params) => dispatch(surveyBegin(...params)),
      getDeptStaff: (...params) => dispatch(getDeptStaff(...params)),
      cachedResults: (...params) => dispatch(cachedResults(...params)),
      updateSurvey: (...params) => dispatch(updateSurvey(...params)),
      createPatient: (...params) => dispatch(createPatient(...params)),
      beginNewSurvey: (...params) => dispatch(beginNewSurvey(...params)),
      getUserDetails: (...params) => dispatch(getUserDetails(...params)),
      executePersonalSurvey: (...params) => dispatch(executePersonalSurvey(...params)),
      rewardPrizeTickets: (...params) => dispatch(rewardPrizeTickets(...params)),
      restartPatientSurvey: (...params) => dispatch(restartPatientSurvey(...params)),
      trackReviewReferClicks: (...params) => dispatch(trackReviewReferClicks(...params))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServeSurvey);
